export default __webpack_public_path__ + "static/media/aqi-good.49dea136.svg";